import Link from 'next/link'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

import type { ServiceFeature } from 'app/RuangGtkHomePageV2/lib/constants'

interface PropsServiceFeatureCard {
  feature: ServiceFeature
  color?: string
}

export default function ServiceFeatureCard({
  feature,
  color,
}: PropsServiceFeatureCard) {
  const featureId = feature.title.replace(/\s+/g, '-').toLowerCase()

  return (
    <Link passHref href={feature.url}>
      <a
        className="block h-full rounded-lg !bg-white p-4 shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 hover:shadow-lg transition-shadow"
        aria-describedby={`feature-desc-${featureId}`}
      >
        <article className="flex h-full flex-col justify-between gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              {feature.icon_url && (
                <img src={feature.icon_url} alt="" width={40} height={40} />
              )}
              <Text
                as="h4"
                variant="heading-md"
                className="!text-xl line-clamp-2 text-ellipsis"
                title={feature.title}
                id={`feature-desc-${featureId}`}
              >
                {feature.title}
              </Text>
            </div>
            <Text
              variant="body-lg"
              className="line-clamp-2 text-ellipsis"
              title={feature.description}
            >
              {feature.description}
            </Text>
          </div>
          <div className={clsx('flex', 'justify-end')}>
            <Icon style={{ color }} aria-hidden="true">
              arrow_forward
            </Icon>
            <span className="sr-only">Buka layanan {feature.title}</span>
          </div>
        </article>
      </a>
    </Link>
  )
}
